import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var ProductsCarousel = function ProductsCarousel() {
  return import('~/components/organisms/Global/ProductsCarousel.vue');
};

var PendingTag = function PendingTag() {
  return import('~/components/functional/TcVars/PendingTag.vue');
};

export default {
  name: 'CrossEarlyBirds',
  components: {
    ProductsCarousel: ProductsCarousel,
    PendingTag: PendingTag
  },
  props: {
    products: {
      type: Array,
      default: null
    },
    reference: {
      type: String,
      default: null
    },
    blockType: {
      type: String,
      default: 'similar'
    }
  },
  computed: {
    displayTracking: function displayTracking() {
      return typeof window !== 'undefined' ? {
        data: {
          event_category: 'FicheProduit',
          event_action: this.blockType === 'similar' ? 'Display_Xsell_EB' : 'Display_Xsell_EB_complementary',
          event_label: "".concat(window.tc_vars.page_cat3, "_").concat(this.reference),
          event_is_non_interactive: 1
        }
      } : {};
    },
    title: function title() {
      return this.$t(this.blockType);
    }
  }
};